"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandRect = expandRect;
function expandRect(_a, _b) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    var left = _b.left, top = _b.top, right = _b.right, bottom = _b.bottom;
    return {
        x: x - left,
        y: y - top,
        width: width + right + left,
        height: height + top + bottom,
    };
}
//# sourceMappingURL=Geometry.js.map